import React, { useState, useEffect, useMemo } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'

import PopUp from '../../../PopupRedesign'
import fetchConditions, {resetConditions} from '../../../shared/actions/refactored/fetchConditions'
import {
  SEARCH_PARAM_ROOM,
  SEARCH_PARAM_DATE_START,
  SEARCH_PARAM_DATE_END,
  SEARCH_PARAM_HOTEL_ID,
  SEARCH_PARAM_ROOM_ID,
  SEARCH_PARAM_ROOM_RATE_ID
} from '../../../search/constants'
import keyCodes from 'js/shared/keyCodes';

import OfferPolicyTab from './OfferPolicyTab';
import OfferDetailsTab from './OfferDetailsTab';
import ConditionsPopupLoader from './ConditionsPopupLoader';

import styles from './ConditionsPopupRedesign.module.scss'

const cx = classnames.bind(styles)

export const CONDITIONS_TAB = 'conditions'
export const DETAILS_TAB = 'details'

const ConditionsPopupRedesign = function (props) {
  const {
    conditions,
    tab,
    parameters,
    fetchRatesConditionsAction,
    resetConditionsAction
  } = props;

  const [activeTab, setActiveTab] = useState(tab)

  const fetchData = () => {
    const {
      roomId,
      hotelId,
      roomRateId,
      apartment,
      dateIn,
      nbNight,
    } = parameters;
    fetchRatesConditionsAction({
      [SEARCH_PARAM_DATE_START]: dateIn,
      [SEARCH_PARAM_DATE_END]: nbNight,
      [SEARCH_PARAM_HOTEL_ID]: hotelId,
      [SEARCH_PARAM_ROOM_ID]: roomId,
      [SEARCH_PARAM_ROOM_RATE_ID]: roomRateId,
      [SEARCH_PARAM_ROOM]: apartment,
    })
  }

  useEffect(() => {
    fetchData()

    return () => {
      resetConditionsAction()
    }
  }, []);

  const tabEventListener = function (e, id) {
    e.preventDefault();

    setActiveTab(id)
  }

  const onKeyDown = function (e, id) {
    if (e.keyCode === keyCodes.enter) {
      tabEventListener(e, id)
    }
  }

  const tabs = useMemo(function () {
    return [{
      id: CONDITIONS_TAB,
      title: conditions?.offerPolicy?.title,
      body: <OfferPolicyTab data={conditions.offerPolicy} />
    }, {
      id: DETAILS_TAB,
      title: conditions?.offerDetails?.title,
      body: <OfferDetailsTab data={conditions.offerDetails} />
    }]
  }, [conditions])

  const activeTabBody = useMemo(function () {
    return tabs.find(tab => tab.id === activeTab)
  }, [tabs, activeTab])

  return (
    <PopUp theme="mobile-full" >
      {!conditions?.fetched && <ConditionsPopupLoader />}
      {conditions?.fetched && (
        <div className={cx('popin')}>
          <div className={cx('tabs-wrap', {'active-right': activeTab === tabs[1].id})}>
            { tabs.map((tab) => (
              <div
                tabIndex="0"
                key={tab.id}
                role="link"
                onKeyDown={(e) => onKeyDown(e, tab.id)}
                onClick={(e) => tabEventListener(e, tab.id)}
                className={cx('tab', { active: activeTab === tab.id })}
              >
                {tab.title}
              </div>
            ))}
          </div>
          <div className={cx('content')}>
            {activeTabBody.body}
          </div>
        </div>
      )}
    </PopUp>
  )
}

ConditionsPopupRedesign.propTypes = {
  conditions: PropTypes.objectOf(Object).isRequired,
  tab: PropTypes.string,
  fetchRatesConditionsAction: PropTypes.func.isRequired,
  resetConditionsAction: PropTypes.func.isRequired,
  parameters: PropTypes.shape({
    nbNight: PropTypes.string.isRequired,
    dateIn: PropTypes.string.isRequired,
    roomId: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]).isRequired,
    roomRateId: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]).isRequired,
    adults: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    childrenAges: PropTypes.arrayOf(PropTypes.number),
    apartment: PropTypes.string,
  }).isRequired
}

ConditionsPopupRedesign.defaultProps = {
  tab: CONDITIONS_TAB,
}

export default connect(({
  popup: {
    data,
  },
  conditions,
}) => ({
  parameters: data,
  conditions,
}),
{
  fetchRatesConditionsAction: fetchConditions,
  resetConditionsAction: resetConditions,
})(ConditionsPopupRedesign)
